import type { CoachResponse } from '@on3/api';
import { useSite } from '@on3/ui-lib/index';
import { currencyFormatterCommas } from '@on3/ui-lib/utils/formatters';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { getSourceUrl } from 'components/Nil/DealTracker/DealTrackerItems/helper';
import { TextLink } from 'components/UI/Link/TextLink';
import { Text } from 'components/UI/Typography/Text';

import styles from './CoachInfo.module.scss';

export const CoachInfo = ({ data }: { data: CoachResponse }) => {
  const {
    age,
    almaMater,
    almaMaterClassYear,
    degree,
    highSchoolAlmaMater,
    homeTownName,
    salary,
    defaultSport,
    salaryUrl,
    organization,
  } = data || {};
  const { defaultYears } = useSite();
  const { footballSeasonYear } = defaultYears;
  const sluggedSport = slugify(defaultSport?.name || 'football');
  const hasJob = !!organization;
  const { name } = highSchoolAlmaMater || {};

  return (
    <div className={styles.coachInfoContainer}>
      {salary && hasJob && (
        <>
          <div className={styles.salaryContainer}>
            <div className={styles.item}>
              <Text
                className={styles.label}
                component="span"
                variant="subtitle1"
              >
                Salary
              </Text>
              <div className={styles.salaryWrapper}>
                <Text
                  className={styles.salaryValue}
                  component="span"
                  variant="subtitle1"
                >
                  {salary ? currencyFormatterCommas(salary) : '-'}
                </Text>
                {salaryUrl && (
                  <TextLink
                    className={styles.source}
                    href={salaryUrl}
                    target="_blank"
                    underline="none"
                    variant="subtitle1"
                  >
                    {getSourceUrl(salaryUrl ?? '', '#6f747b')}
                    Source
                  </TextLink>
                )}
              </div>
            </div>
          </div>

          <TextLink
            className={styles.salaryIndex}
            href={`/db/coach/salaries/${sluggedSport}/${footballSeasonYear}/`}
            underline="none"
            variant="subtitle1"
          >
            Coach Salaries Index
          </TextLink>
        </>
      )}
      <div className={styles.item}>
        <Text className={styles.label} component="span" variant="subtitle1">
          Alma Mater
        </Text>
        <Text className={styles.value} component="span" variant="subtitle1">
          {almaMater?.name ?? '-'}
          {almaMaterClassYear && (
            <span className={styles.almaMaterClassYear}>
              &#47; {almaMaterClassYear}
            </span>
          )}
        </Text>
      </div>
      <div className={styles.item}>
        <Text className={styles.label} component="span" variant="subtitle1">
          Degree
        </Text>
        <Text className={styles.value} component="span" variant="subtitle1">
          {degree ?? '-'}
        </Text>
      </div>
      <div className={styles.item}>
        <Text className={styles.label} component="span" variant="subtitle1">
          Age
        </Text>
        <Text className={styles.value} component="span" variant="subtitle1">
          {age ?? '-'}
        </Text>
      </div>
      <div className={styles.item}>
        <Text className={styles.label} component="span" variant="subtitle1">
          High School
        </Text>
        <Text className={styles.value} component="span">
          {name ?? '-'}
        </Text>
      </div>
      <div className={styles.item}>
        <Text className={styles.label} component="span" variant="subtitle1">
          Hometown
        </Text>
        <Text className={styles.value} component="span" variant="subtitle1">
          {homeTownName ?? '-'}
        </Text>
      </div>
    </div>
  );
};
